export default __webpack_public_path__ + "static/media/nice.ddf1f1c2.webp";